import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import usePageMetadata from '../utils/usePageMetadata';
import './Auth.css';

const VerifyEmail = () => {
  usePageMetadata({
    title: 'Verify Email | The Ad Shop',
    description: 'Verify your email address to complete your Ad Shop account registration.',
    canonicalUrl: 'https://theadshop.co/verify-email',
    meta: [
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  });
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error, expired
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }

    // Verify email via API
    const verifyEmail = async () => {
      try {
        await axios.get(`/api/auth/verify-email?token=${token}`);
        // If successful, the backend redirects, but we can also handle it here
        setStatus('success');
        setMessage('Your email has been verified successfully! Redirecting to login...');
        setTimeout(() => {
          // Redirect to login with onboarding flag
          navigate('/login?onboarding=true');
        }, 3000);
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'Verification failed';
        if (errorMessage.includes('expired')) {
          setStatus('expired');
          setMessage('This verification link has expired. Please request a new one.');
        } else {
          setStatus('error');
          setMessage(errorMessage);
        }
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="page-container">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <img src="/images/the-ad-shop-logo.svg" alt="The Ad Shop" className="auth-logo" />
            <h1>Email Verification</h1>
          </div>

          {status === 'verifying' && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <div className="spinner" style={{ margin: '0 auto 1rem' }}></div>
              <p>{message}</p>
            </div>
          )}

          {status === 'success' && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{ fontSize: '3rem', color: '#10b981', marginBottom: '1rem' }}>✓</div>
              <h2 style={{ color: '#10b981', marginBottom: '1rem' }}>Email Verified!</h2>
              <p style={{ color: '#6b7280', marginBottom: '2rem' }}>{message}</p>
              <button 
                onClick={() => navigate('/login')}
                className="btn btn-primary"
              >
                Go to Login
              </button>
            </div>
          )}

          {status === 'expired' && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{ fontSize: '3rem', color: '#f59e0b', marginBottom: '1rem' }}>⏰</div>
              <h2 style={{ color: '#f59e0b', marginBottom: '1rem' }}>Link Expired</h2>
              <p style={{ color: '#6b7280', marginBottom: '2rem' }}>{message}</p>
              <button 
                onClick={() => navigate('/login')}
                className="btn btn-primary"
              >
                Go to Login
              </button>
            </div>
          )}

          {status === 'error' && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{ fontSize: '3rem', color: '#ef4444', marginBottom: '1rem' }}>✗</div>
              <h2 style={{ color: '#ef4444', marginBottom: '1rem' }}>Verification Failed</h2>
              <p style={{ color: '#6b7280', marginBottom: '2rem' }}>{message}</p>
              <button 
                onClick={() => navigate('/login')}
                className="btn btn-primary"
              >
                Go to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;










